import React, { useState, useEffect } from 'react';
import { css } from '@emotion/react';
import { useAuth } from '@/context/AuthContext';
import { Hamburger } from '@/components/base/header/Hamburger';
import { Menu } from '@/components/base/header/Menu';

const baseUrl = 'https://legalengine.co.kr';

export const StandardHeader = () => {
  const [open, setOpen] = useState<boolean>(false);
  const { user } = useAuth();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  useEffect(() => {
    setIsAuthenticated(!!user);
  }, [user]);

  return (
    <header
      css={css`
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        display: flex;
        display: -ms-flexbox;
        height: 65px;
        border-bottom: 0.5px solid #d1d1d1;
        background-color: white;
        z-index: 1030;
        @media (max-width: 992px) {
          display: block;
          height: 40px;
          text-align: center;
        }
      `}
    >
      <div
        css={css`
          /* flex: 0.8; */
          @media (max-width: 992px) {
            text-align: center;
          }
        `}
      >
        <a href={`${baseUrl}`}>
          <img
            css={css`
              width: 12rem;
              margin-left: 1.5rem;
              margin-top: 0.5rem;
              height: 55px;
              cursor: pointer;
              @media (max-width: 992px) {
                width: 120px;
                margin-top: 10px;
                height: 25px;
                cursor: pointer;
              }
            `}
            src={'/logo/logo.svg'}
            alt={'Legal Engine'}
          />
        </a>
        <span
          css={css`
            display: inline-block;
            padding-top: 16px;
            vertical-align: top;
            font-size: 12px;
            color: rgb(229, 25, 42);
            font-weight: 600;
            @media (max-width: 992px) {
              padding-top: 0;
            }
          `}
        >
          {`beta`}
        </span>
      </div>
      <nav
        css={css`
          flex: 1;
          align-self: center;
        `}
      >
        {/* <HeaderSearchbar /> */}
      </nav>
      <nav
        css={css`
          display: flex;
          display: -ms-flexbox;
          justify-items: center;
          align-self: center;
          a {
            text-decoration: none;
          }
          @media (max-width: 992px) {
            display: none;
          }
        `}
      >
        <a
          css={css`
            display: flex;
            flex-flow: row nowrap;
            justify-items: center;
            align-self: center;
          `}
          href='/crimesearch'
        >
          <div
            css={css`
              font-weight: 500;
              font-size: 1rem;
              line-height: 23px;
              text-align: center;
              cursor: pointer;
              color: black;
              padding-right: 0.2rem;
              &:hover {
                text-decoration: none;
                font-weight: 600;
              }
            `}
          >
            {`무죄판결 검색`}
          </div>
          <div
            css={css`
              position: relative;
              bottom: 10px;
              align-self: center;
              font-size: 12px;
              color: rgb(229, 25, 42);
              font-weight: 600;
              padding-right: 0.5rem;
            `}
          >
            {`new`}
          </div>
        </a>
        {/*<a href={`${baseUrl}/requestcase`}>
          <div
            css={css`
              font-weight: 500;
              font-size: 1rem;
              line-height: 23px;
              text-align: center;
              cursor: pointer;
              color: black;
              padding-top: 5px;
              padding-right: 1.3rem;
              &:hover {
                text-decoration: none;
                font-weight: 600;
              }
            `}
          >
            {`판례 요청`}
          </div>
        </a>*/}
        <a href={`${baseUrl}/posts`}>
          <div
            css={css`
              font-weight: 500;
              font-size: 1rem;
              line-height: 23px;
              text-align: center;
              cursor: pointer;
              color: black;
              padding-top: 5px;
              padding-right: 1.3rem;
              &:hover {
                text-decoration: none;
                font-weight: 600;
              }
            `}
          >
            {`포스트`}
          </div>
        </a>
        <a href={`${baseUrl}/translator`}>
          <div
            css={css`
              font-weight: 500;
              font-size: 1rem;
              line-height: 23px;
              text-align: center;
              cursor: pointer;
              color: black;
              padding-top: 5px;
              padding-right: 1.3rem;
              &:hover {
                text-decoration: none;
                font-weight: 600;
              }
            `}
          >
            법률 번역
          </div>
        </a>
        {isAuthenticated ? (
          <a href={`${baseUrl}/user/profile/info`}>
            <div
              css={css`
                border-radius: 15px;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                padding: 0.2rem 0.6rem 0.3rem 0.6rem;
                cursor: pointer;
                font-weight: 500;
                font-size: 1rem;
                line-height: 23px;
                margin-right: 1.4rem;
                text-align: center;
                color: #002366;
                border: 1px solid #002366;
                &:hover {
                  text-decoration: none;
                  font-weight: 600;
                }
              `}
            >
              {`프로필`}
            </div>
          </a>
        ) : (
          <>
            <a href={`${baseUrl}/user/login`}>
              <div
                css={css`
                  border-radius: 15px;
                  -webkit-box-sizing: border-box;
                  box-sizing: border-box;
                  padding: 0.2rem 0.6rem 0.3rem 0.6rem;
                  cursor: pointer;
                  font-weight: 500;
                  font-size: 1rem;
                  line-height: 23px;
                  margin-right: 1.4rem;
                  text-align: center;
                  color: #002366;
                  border: 1px solid #002366;
                  &:hover {
                    text-decoration: none;
                    font-weight: 600;
                  }
                `}
              >
                {`로그인`}
              </div>
            </a>
            <a href={`${baseUrl}/user/signup`}>
              <div
                css={css`
                  border-radius: 15px;
                  -webkit-box-sizing: border-box;
                  box-sizing: border-box;
                  padding: 0.2rem 0.6rem 0.3rem 0.6rem;
                  cursor: pointer;
                  font-weight: 500;
                  font-size: 1rem;
                  line-height: 23px;
                  margin-right: 1.4rem;
                  text-align: center;
                  color: white;
                  background-color: #002366;
                  &:hover {
                    text-decoration: none;
                    font-weight: 600;
                  }
                `}
              >
                {`회원가입`}
              </div>
            </a>
          </>
        )}
      </nav>
      <Hamburger open={open} setOpen={setOpen} />
      <Menu open={open} isAuthenticated={isAuthenticated} />
    </header>
  );
};
